import { render, staticRenderFns } from "./operation-log-model.vue?vue&type=template&id=3fd89b28&scoped=true"
import script from "./operation-log-model.vue?vue&type=script&lang=js"
export * from "./operation-log-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd89b28",
  null
  
)

export default component.exports